import styled from '@emotion/styled';
import { Typography } from 'antd';
import { TextProps } from 'antd/es/typography/Text';
import { FC } from 'react';

import { LogoIcon } from '../Icon';

interface LogoProps {
  collapsed: boolean;
}

interface TextCustomProps extends TextProps {
  collapsed: string;
}

const Text = styled(Typography.Text)<TextCustomProps>`
  color: #ffffff;
  font-size: 15px;
  font-weight: 600;
  white-space: pre-wrap;
  word-wrap: break-word;
  line-height: normal;
  margin-left: 8px;
  display: ${({ collapsed }) => (collapsed === 'true' ? 'none' : 'block')};
  transition: display 0.3s;
`;

const Container = styled.div`
  display: flex;
  align-items: center;
`;

const ALink = styled.a`
  cursor: pointer;
`;
export const Logo: FC<LogoProps> = ({ collapsed }) => (
  <Container className={collapsed ? 'p-3' : 'px-6 py-3'}>
    <ALink href="/">
      <LogoIcon width={46} height={30} isWhite />
    </ALink>
    <ALink href="/">
      <Text collapsed={String(collapsed)}>
        Rectangle
        <br />
        Sheetmetal
      </Text>
    </ALink>
  </Container>
);
